import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import {PropsWithChildren} from 'react';
import {v4 as uuidv4} from 'uuid';
import useStyles from './tables-styles';

type Props = PropsWithChildren<{
  headers: string[];
  variant?: `leaderboard` | `normal`;
}>;
const BaseTable = (props: Props) => {
  const {headers, children, variant} = props;
  const classes = useStyles();

  const renderHeader = () => {
    if (variant === `leaderboard`) {
      return headers.map((value, i) => {
        return (
          <TableCell
            style={{width: i === 0 ? 500 : '100%'}}
            align="left"
            key={uuidv4()}
          >
            {value}
          </TableCell>
        );
      });
    }

    return headers.map((value, i) => {
      return (
        <TableCell align={i !== 0 ? `right` : 'left'} key={uuidv4()}>
          {value}
        </TableCell>
      );
    });
  };

  return (
    <>
      <TableContainer
        className={classes.table_container}
        component={(props) => <Paper {...props} variant="outlined" />}
      >
        <Table size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {renderHeader()}
              {/* {headers.map((value, i) => {
                return (
                  <TableCell align={i !== 0 ? `right` : 'left'} key={uuidv4()}>
                    {value}
                  </TableCell>
                );
              })} */}
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
BaseTable.defaultProps = {
  variant: `normal`,
};

export default BaseTable;
